<template>
  <!-- 语音通话 组件 -->
  <div v-if="show">
    <!-- 蒙版 -->
    <div class="mask" @touchmove.prevent v-if="!soloPage"></div>
    <div class="pop">
      <div class="voice walkie">
        <el-container>
          <el-aside>
            <div class="conver-title">
              <div class="title-name">{{ title }}</div>
              <div class="flex">
                <div
                  class="call"
                  :class="theme === 'default' ? 'call-d' : 'call-m'"
                  @click="quickCall"
                  :title="i18n.t('quickCall')"
                ></div>
                <div
                  class="add"
                  :class="theme === 'default' ? 'add-d' : 'add-m'"
                  @click="addNew('add')"
                  :title="i18n.t('newGroup')"
                ></div>
              </div>
            </div>
            <div class="search">
              <el-input :placeholder="i18n.t('searchM')" v-model="userName" class="search-name">
                <i slot="prefix" class="el-input__icon el-icon-search"></i>
              </el-input>
            </div>
            <div class="serachLine">
              <ul>
                <li
                  v-for="(item, index) in searchData"
                  :key="index"
                  @click="currenGroup(item)"
                  :class="[currenData.id === item.id ? 'curren-hight' : '', index === hoverIndex ? 'hoverBg' : '']"
                  @mouseenter="hoverIndex = index"
                >
                  <div class="info-port">
                    <img
                      v-if="currenData.id === item.id && theme !== 'default'"
                      src="@/icon/voice/ic_group.png"
                      class="group_icon"
                    />
                    <img
                      v-if="currenData.id !== item.id && theme !== 'default'"
                      src="@/icon/voice/person_off.png"
                      class="group_icon"
                    />
                    <img
                      v-if="currenData.id === item.id && theme === 'default'"
                      src="@/icon/voice/icon_light_on.png"
                      class="group_icon"
                    />
                    <img
                      v-if="currenData.id !== item.id && theme === 'default'"
                      src="@/icon/voice/icon_light_off.png"
                      class="group_icon"
                    />
                    <p
                      class="broad-name"
                      :class="theme === 'default' ? 'name-light' : 'name-dark'"
                      :title="item.groupName"
                    >
                      {{ item.groupName | ellipsisEight }}
                    </p>
                    <p>{{ item.ouName }}</p>
                  </div>
                  <div class="icon-right">
                    <div class="last-time">{{ item.lastVoiceTime }}</div>
                    <img src="@/icon/ic_delete.png" class="addicon" @click="delectItem(item)" />
                  </div>
                </li>
                <li v-if="searchData.length === 0" class="no-data">
                  {{ i18n.t('NoVoiceGroup') }}
                </li>
              </ul>
            </div>
          </el-aside>
          <el-main>
            <div class="log-title">
              <span>{{ searchData.length ? currenData.groupName : '' }}</span>
              <div
                class="groupArr"
                :class="theme === 'default' ? 'group-light' : 'group-dark'"
                v-if="searchData.length !== 0"
                alt=""
              ></div>
              <i v-if="!soloPage" @click="infinityVoice" class="sys-close-btn close"></i>
            </div>
            <div id="person">
              <div class="person-list" ref="chatContent" v-if="currenData.userList.length > 0">
                <div class="leader" v-if="searchData.length !== 0">{{ i18n.t('createdBy') }}: {{ creatorName }}</div>
                <!-- 群组成员视图 -->
                <ul>
                  <li class="person-list-item" v-for="(item, index) in currenData.userList" :key="index">
                    <div class="flex">
                      <div class="portrait">
                        <!-- {{ item.userName | firstName }} -->
                      </div>
                      <div>
                        <div class="portrait-user">
                          {{ item.userName | ellipsisWalkie }}
                        </div>
                        <!-- <div>{{ currenData.groupName | ellipsisWalkie }}</div> -->
                      </div>
                      <div class="status_person" v-if="item.helmetId">
                        <i class="status_cricl" :class="item.onlineStatus == 1 ? 'status_on' : 'status_off'"></i>
                        <span :class="item.onlineStatus == 1 ? 'person_on' : 'person_off'">{{
                          item.onlineStatus == 1 ? i18n.t('onLine') : i18n.t('offLine')
                        }}</span>
                      </div>
                    </div>
                  </li>
                  <li
                    class="person-add"
                    :class="theme === 'default' ? 'add-light' : 'add-dark'"
                    @click="changeArr"
                    v-if="userid === currenData.creator"
                  >
                    <img
                      :src="require(theme === 'default' ? '@/icon/add_light.png' : '@/icon/add_more.png')"
                      :alt="i18n.t('addTo')"
                    />
                    <p class="add_more">{{ i18n.t('addTo') }}</p>
                  </li>
                </ul>
              </div>
              <audio ref="audio" id="walkieAudio" autoplay></audio>
            </div>
            <div class="talk">
              <!-- 语音 -->
              <div class="play-icon" @click="toDialog">
                <div class="play-light"></div>
              </div>
            </div>
          </el-main>
        </el-container>
      </div>
      <el-dialog title="" :visible.sync="setAlertVisible" width="50%" top="3%" :close-on-click-modal="false">
        <div id="setRecord">
          <div class="addRecord">
            <img @click="setAlertVisible = false" class="back-record" src="@/icon/back.png" alt="" />
            <span class="addRecord-title">{{
              editType === '1' ? i18n.t('EditVoiceGroups') : i18n.t('CreateVoiceCall')
            }}</span>
            <i @click="setAlertVisible = false" class="sys-close-btn"></i>
          </div>
          <div class="group">
            <div class="group-name">{{ i18n.t('voiceGroupName') }}</div>
            <el-input :placeholder="i18n.t('please')" v-model="groupName" maxlength="16" class="search-add"></el-input>
            <div class="select-title">{{ i18n.t('SelectMembers') }}</div>
            <el-input :placeholder="i18n.t('searchM')" v-model="addUsername" class="search-add">
              <i slot="prefix" class="el-input__icon el-icon-search"></i>
            </el-input>
          </div>
          <div class="broad">
            <div v-if="ouList.length > 0">
              <elTree2
                ref="userTree"
                :data="ouList"
                :check-on-click-node="true"
                :default-checked-keys="userCheckedList"
                show-checkbox
                node-key="userId"
                :filter-node-method="filterNode"
                default-expand-all
                :check-strictly="true"
                :props="ouTreeProps"
              >
              </elTree2>
            </div>
            <div v-else class="setTree">
              {{ i18n.t('bindAvailable') }}
            </div>
          </div>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" v-if="editType === '0'" @click="updateUser()">{{ i18n.t('determine') }}</el-button>
          <el-button type="primary" v-if="editType === '1'" @click="editUser()">{{ i18n.t('determine') }}</el-button>
          <el-button @click="cancelUpdate">{{ i18n.t('cancel') }}</el-button>
        </span>
      </el-dialog>
      <WalkieQuickCallDialog
        :ouList="ouList"
        :WalkieQuickCallDialogVisible.sync="WalkieQuickCallDialogVisible"
        @toDialog="toDialog"
      >
      </WalkieQuickCallDialog>
      <WalkieCallingDialog
        :isEnterRoom="isEnterRoom"
        :isCancelOne.sync="isCancelOne"
        :currenData="currenData"
        :WalkieCallingDialogVisible="WalkieCallingDialogVisible"
        @handleCurrent="handleCurrent"
        @clearCurrenDateList="clearCurrenDateList"
        @closeCallingWind="closeCallingWind"
      ></WalkieCallingDialog>
      <!-- 语音播放节点 -->
      <div id="walkieDom"></div>
    </div>
  </div>
</template>
<script>
import {
  findWalkieList,
  saveWalkieGroup,
  deleteWalkieGroup,
  editWalkieGroup,
  getUserTreeWalkie,
} from '@/api/walkie/walkie'

import { findDeviceList } from '@/api/monitor'
import store from '@/store/index'
import elTree2 from '@/components/vTree/src/tree'
import { getSession } from '@/api/common'
import WalkieCallingDialog from '@/components/walkie/WalkieCallingDialog.vue'
import WalkieQuickCallDialog from '@/components/walkie/WalkieQuickCallDialog.vue'
import { errorCollection } from '@/api/dmp/dmpCollection'
import { mapGetters } from 'vuex'
import { joinMeetWaike, joinRoomWaike } from '@/common/rtc/index'

import { setIsWalkieResponse } from '@/common/websocket/index'
import i18n from '@/common/i18n'

export default {
  data() {
    return {
      i18n: i18n,
      hoverIndex: -1,
      // 新增或者编辑类型
      editType: '',
      // 查询树状态 0 在线，1离线
      statusList: [0, 1],
      // 对讲组件显隐控制，对应$AlertWalkie全局组件传入的状态
      show: false,
      title: i18n.t('voiceCall'),
      // 搜索用户名
      userName: '',
      // 对讲组数据
      searchData: [],
      // 新增对讲组弹框显隐
      setAlertVisible: false,
      ouTreeProps: {
        label: 'name',
        children: 'children',
      },
      // 新增对讲组组织树列表
      ouList: [],
      // 组织树成员搜索用户名
      addUsername: '',
      // 当前选中对讲组数据
      currenData: {
        userList: [],
      },
      // 组名称
      groupName: '',
      // 选中列表
      userCheckedList: [],
      // 当前登录用户userid
      userid: getSession('userId'),
      // 主题区分
      theme: localStorage.getItem('theme'),
      // 对讲正在通话成员显隐
      WalkieCallingDialogVisible: false,
      // 快速通话显隐
      WalkieQuickCallDialogVisible: false,
      // 电话是否接通状态
      isEnterRoom: false,
      creatorName: '',
      soloPage: false,
    }
  },
  components: { elTree2, WalkieCallingDialog, WalkieQuickCallDialog },
  methods: {
    // 语音结束后 还在当前item
    handleCurrent() {
      this._findWalkieList(this.currenData.groupName)
    },
    // 关闭对讲组件
    infinityVoice() {
      this.show = false
      store.commit('walkieShow', false)
    },
    // 删除群组
    delectItem(node) {
      // creator 代表当前群组是谁创建的 只有创建人才能删除或修改群组
      if (this.currenData.creator !== this.userid) {
        this.$message({
          message: i18n.t('noPermissionModify'),
          type: 'error',
        })
        errorCollection('语音通讯-语音通话', '删除群组', { status: 200, data: { state: -1, msg: '无权修改群组信息' } })
        return
      }
      this.$confirm(i18n.t('deleteGroup'), {
        confirmButtonText: i18n.t('determine'),
        cancelButtonText: i18n.t('cancel'),
        type: 'warning',
        closeOnClickModal: false,
      }).then(() => {
        deleteWalkieGroup(node.id).then(res => {
          if (res.state === 0) {
            this.$message({
              message: i18n.t('deleteSuccess'),
              type: 'success',
            })
            this.clearCurrenDateList()
            this._findWalkieList()
          }
        })
      })
    },
    addNew(type) {
      // 点击添加人员、群
      if (type === 'add') {
        this.userCheckedList = []
        this.groupName = ''
        this.editType = '0'
      } else {
        this._getUserTree()
        this.editType = '1'
      }
      this.addUsername = ''
      let params = {
        userName: this.addUsername,
        statusList: this.statusList,
        specType: 1,
        ifPosition: 1,
        specTypeList: [1, 2],
      }
      // 获取设备列表
      findDeviceList(params).then(res => {
        // console.log(res.data)
        if (res.state === 0) {
          this.ouList = res.data
          this.setAlertVisible = true
        }
      })
    },
    // 快速呼叫
    quickCall() {
      let params = {
        userName: '',
        statusList: this.statusList,
        specType: 1,
        ifPosition: 1,
        specTypeList: [1, 2],
      }
      // 获取设备列表
      findDeviceList(params).then(res => {
        if (res.state === 0) {
          this.ouList = res.data
          this.WalkieQuickCallDialogVisible = true
        }
      })
    },
    // 获取群组人员列表树
    _getUserTree() {
      this.userCheckedList = []
      let params = {
        roomId: this.currenData.id,
      }
      getUserTreeWalkie(params).then(res => {
        console.log(res.data)
        if (res.state === 0) {
          for (let item of res.data) {
            this.userCheckedList.push(item.userId)
          }
          // console.log(this.userCheckedList, this.$refs.userTree)
          this.$nextTick(() => {
            if (this.ouList.length > 0) {
              this.$refs.userTree.setCheckedKeys(this.userCheckedList)
            }
          })
        }
      })
    },
    // 编辑群人员
    changeArr() {
      this.groupName = this.currenData.groupName
      if (this.currenData.creator !== this.userid) {
        this.$message({
          message: '无权修改群组信息',
          type: 'error',
        })
        errorCollection('语音通讯-语音通话', '编辑群人员', {
          status: 200,
          data: { state: -1, msg: '无权修改群组信息' },
        })
        return
      }
      this.addNew('edit')
    },
    // 查询已有群组列表
    _findWalkieList(name) {
      let params = {
        groupName: this.userName,
      }
      findWalkieList(params).then(res => {
        if (res.state === 0) {
          this.searchData = res.data
          // 当前未选中时自动展示第一个
          if (name) {
            // 当点击通话后 返回重新请求 当前的用户组
            if (this.currenData.groupName || name) {
              for (let item of this.searchData) {
                if (this.currenData.groupName === item.groupName || name === item.groupName) {
                  this.currenData = item
                }
              }
            }
          } else {
            if (this.currenData.userList.length === 0) {
              if (this.searchData[0]) {
                this.currenData = this.searchData[0]
              }
            }
          }
          // 查询出的数据没有时清空list
          if (res.data.length === 0) {
            this.clearCurrenDateList()
          }
        }
        this.creatorName = this.currenData.creatorName
      })
    },
    // 当前群组
    currenGroup(item) {
      this.currenData = item
      this.creatorName = this.currenData.creatorName
    },
    // 清空当前选中的list
    clearCurrenDateList() {
      this.currenData.userList = []
    },
    // 关闭当前通话弹窗
    closeCallingWind() {
      // 用户退出房间时，除非再次发起通话，不然不会再次进入房间
      store.commit('isCancelOne', false)
      this.WalkieCallingDialogVisible = false
    },
    filterNode(value, data) {
      if (!value) return true
      return data.name.indexOf(value) !== -1
    },
    // 编辑群名/人员
    editUser() {
      if (this.currenData.creator !== this.userid) {
        this.$message({
          message: '无权修改群组信息',
          type: 'error',
        })
        errorCollection('语音通讯-语音通话', '编辑群名/人员', {
          status: 200,
          data: { state: -1, msg: '无权修改群组信息!' },
        })
        return
      }
      let NodesArr = this.$refs.userTree.getCheckedNodes()
      // console.log(NodesArr)
      let idArr = []
      for (let item of NodesArr) {
        if (item.userId) {
          idArr.push(item.userId)
        }
      }
      if (this.groupName === '') {
        this.$message({ type: 'error', message: '请输入语音通话群组名称!' })
        errorCollection('语音通讯-语音通话', '编辑群组名/人员', {
          status: 200,
          data: { state: -1, msg: '请输入语音通话群组名称!' },
        })
      } else if (idArr.length === 0) {
        this.$message({ type: 'error', message: '请选择至少一位群组员!' })
        errorCollection('语音通讯-语音通话', '编辑群组名/人员', {
          status: 200,
          data: { state: -1, msg: '请选择至少一位群组员!' },
        })
      } else {
        let params = {
          id: this.currenData.id,
          groupName: this.groupName,
          userIds: idArr,
        }
        editWalkieGroup(params).then(res => {
          if (res.state === 0) {
            this.$message({
              message: i18n.t('EditSucceeded'),
              type: 'success',
            })
            this.clearCurrenDateList()
            this._findWalkieList(this.groupName)
            this.setAlertVisible = false
            this.groupName = ''
          }
        })
      }
    },
    // 新增对讲组
    updateUser() {
      let NodesArr = this.$refs.userTree.getCheckedNodes()
      // console.log(NodesArr)
      let idArr = []
      for (let item of NodesArr) {
        if (item.userId) {
          idArr.push(item.userId)
        }
      }
      if (this.groupName === '') {
        this.$message({ type: 'error', message: '请输入语音通话群组名称!' })
        errorCollection('语音通讯-语音通话', '新增语音通话组', {
          status: 200,
          data: { state: -1, msg: '请输入语音通话群组名称!' },
        })
      } else if (idArr.length === 0) {
        this.$message({ type: 'error', message: '请选择至少一位群组员!' })
        errorCollection('语音通讯-语音通话', '新增语音通话组', {
          status: 200,
          data: { state: -1, msg: '请选择至少一位群组员!' },
        })
      } else {
        let params = {
          groupName: this.groupName,
          userIds: idArr,
        }
        saveWalkieGroup(params).then(res => {
          if (res.state === 0) {
            this.$message({
              message: i18n.t('AddSuccess'),
              type: 'success',
            })
            this.currenData.groupName = this.groupName
            this.clearCurrenDateList()
            this._findWalkieList(this.groupName)
            this.setAlertVisible = false
            this.groupName = ''
          }
        })
      }
    },
    cancelUpdate() {
      this.setAlertVisible = false
    },
    // 发起通话
    toDialog(type, idArr) {
      // 非快速呼叫，当前无群组时禁止呼叫
      if (type !== 'quick' && this.currenData.userList.length === 0) {
        this.$message({ type: 'error', message: '请先选择群组!' })
        return
      }
      // 复原电话是否接通状态
      this.isEnterRoom = false
      // 本机发起通话
      store.commit('handleIsLocalWalkie', true)
      // 默认第一次发起通话时 退出对讲前都可以
      store.commit('isCancelOne', true)
      // this.userName = ''

      let id = this.currenData.id
      let userList = this.currenData.userList
      let userId = getSession('userId')
      // 给每个用户添加acceptCall，用来判断呼叫，接通等状态 0：呼叫中（具体字段含义过滤器查看）
      for (var i = 0; i < userList.length; i++) {
        if (userList[i].userId === userId) {
          userList[i].acceptCall = ''
        } else {
          userList[i].acceptCall = '0'
        }
      }
      this.currenData.userList = userList
      // 快速呼叫时判断
      if (type === 'quick') {
        id = Math.floor(Math.random() * 1000000)
        userList = idArr
        for (var k = 0; k < userList.length; k++) {
          userList[k].acceptCall = '0'
        }
        // console.log('quickuserList', userList)
        this.currenData.userList = userList
        this.currenData.groupName = ''
      }
      let helmetList = []
      // 用户列表除去自己
      for (var j = 0; j < userList.length; j++) {
        if (userId !== userList[j].userId) {
          helmetList.push(userList[j].helmetId)
        }
      }
      this.WalkieCallingDialogVisible = true

      // console.log('this.currenData',this.currenData)
      // 发送加入房间指令
      joinMeetWaike(helmetList, id)
    },
    // ws响应进房事件
    handWalkieResponse(params) {
      var status = JSON.parse(params.msg)
      console.log(status, 'status')
      let roomId = status.content.params.roomId
      // 收到房间号时表示电话接通
      if (roomId) {
        this.isEnterRoom = true
      }
      let userList = this.currenData.userList
      // 离线时改变状态
      if (status.content.params.offLine) {
        let offLineArr = JSON.parse(status.content.params.offLine)
        for (var i = 0; i < userList.length; i++) {
          for (var k = 0; k < offLineArr.length; k++) {
            if (offLineArr[k] === userList[i].helmetId) {
              userList[i].acceptCall = '5'
            }
          }
        }
      }
      // 匹配返回的from值改变acceptCall
      for (var j = 0; j < userList.length; j++) {
        if (status.header.from === userList[j].helmetId) {
          if (status.content.params.acceptCall) {
            // 接听状态
            userList[j].acceptCall = status.content.params.acceptCall
          } else if (status.content.params.hangUp && status.content.params.hangUp === '1') {
            // 接通后挂断状态
            userList[j].acceptCall = '6'
          }
        }
      }
      this.currenData.userList = userList
      // 解决子组件不刷新问题
      this.currenData.userList.push()
      if (status.header.from === 'SYS') return
      // trtc加入房间
      if (this.isCancelOne) {
        joinRoomWaike(roomId)
      }
    },
  },
  mounted() {
    if (getSession('username')) {
      this._findWalkieList()
    }
    // 设置响应函数
    setIsWalkieResponse(this.handWalkieResponse)
    if (window.location.href.includes('/Intercom')) {
      this.soloPage = true
    }
  },
  watch: {
    // 监听已有人员查询
    userName(val) {
      this._findWalkieList()
    },
    addUsername(val) {
      // 监听新增用户查询
      this.$refs.userTree.filter(val)
    },
    getTheme(val) {
      this.theme = val
    },
    walkieShow(val) {
      if (val === false) {
        this.show = false
      }
    },
  },
  computed: {
    ...mapGetters(['rtcType']),
    // 主题切换标识监听
    getTheme() {
      return store.state.theme
    },
    walkieShow() {
      return store.state.walkieShow
    },
    isCancelOne() {
      return store.state.isCancelOne
    },
  },
}
</script>
<style lang="stylus" rel="stylesheet/stylus" scoped>
@import '~@/style/mixin.styl'
// 渐变过渡
.fade-enter, .fade-leave-active
  opacity 0
.fade-enter-active, .fade-leave-active
  transition opacity 0.35s
// 全局弹窗
.mask
  position fixed
  top 0
  z-index 10
  width 100%
  height 100%
.pop
  width 100% !important
  height 100% !important
  min-width 500px;/*no*/
  border-radius 8px
  position fixed
  top 50%
  left 50%
  transform translate(-50%, -50%)
  z-index 2080
  .el-aside
    width 15% !important
    max-width: 300px !important;
.el-main
  width 85% !important
.voice
  height 100% !important
  .conver-title
    display flex
    justify-content space-between
    font-size 20px
    padding 15px
    .title-name
      font-weight 600
    .call
      cursor pointer
      margin-right 6px
      width 24px
      height 24px
    .call-d
      bg-image-full('~@/icon/call.png')
    .call-m
      bg-image-full('~@/icon/call_m.png')
    .add
      cursor pointer
      width 24px
      height 24px
    .add-d
      bg-image-full('~@/icon/rcord_add.png')
    .add-m
      bg-image-full('~@/icon/rcord_add-m.png')
  .search
    text-align center
  .search-name
    width 100% !important
    font-size: 18px
.serachLine
  height 89%
  overflow auto
  margin-top 15px
  ul
    li
      position relative
      display flex
      align-items center
      padding 15px
      border-bottom 1px solid var(--pop-head-port-bg)
      .head-port
        position relative
        width 40px
        line-height 40px
        margin-right 10px
        border-radius: 8px
        font-size: 20px
        text-align center
        .is-read
          position absolute
          top 0
          right 0
          display block
          width 5px;/*no*/
          height 5px;/*no*/
          border-radius 50%
          background red
      .info-port
        display flex
        align-items center
        font-size 14px
        .person-name
          font-size 16px
          font-weight bold
        .broad-name
          width 130px
          overflow: hidden
          text-overflow: ellipsis
          white-space: nowrap
          font-size 16px
          font-weight bold
        .group_icon
          width 20px
          height 20px
          margin-right 10px
      .icon-right
        position absolute
        right 5px
        .last-time
          font-size 12px
          margin-bottom 3px
        .addicon
          display none
          width 20px
    .hoverBg
      &:hover .addicon
        display block
    .curren-hight
      background rgba(#666,0.2)
      .name-light
        color #0E65DD!important
      .name-dark
        color #00DEFF!important
    .no-data
      color #999
      cursor default
#audio
  display none
.log-title
  position relative
  height 50px
  border-radius 4px
  padding-left 22px
  display flex
  align-items: center
  .leader
    position absolute
    left 50%
    top 0px
    transform translate(-50%,0)
    font-size 18px
    color var(--black-color)
  span
    line-height 50px
    font-size 20px
  .groupArr
    display inline-block
    width 24px
    height 24px
    margin-left 10px
  .group-light
    bg-image-full('~@/icon/group.png')
  .group-dark
    bg-image-full('~@/icon/ic_group.png')
  .close
    position absolute
    top 50%
    right 10px
    transform translate(0, -50%)
    display block
    cursor pointer
#person
  height 78%
  padding-left 20px
  padding-right 20px
  padding-top 15px
  padding-bottom 15px
  .person-list
    height 390px
    overflow auto
    .leader
      margin-bottom 14px
      font-size 18px
      color var(--black-color)
    .person-list-item
      position relative
      cursor: auto;
      margin: 0.04166667rem;
      width 180px
      height: 0.41666667rem;
      border-radius: 0.02083333rem;
      display: inline-block;
      margin-bottom: 0.11979167rem;
      padding: 0.10416667rem 0.08333333rem;
      box-sizing: border-box;
      .member-staus
        padding 7px
        position absolute
        top 0px
        right 0px
      .portrait
        flex-shrink: 0
        width: 40px
        height: 40px
        margin 0 10px
        border-radius: 8px
        font-size: 20px
        text-align center
        line-height 40px
        color var(--pop-head-port-color)
        background var(--pop-head-port-bg)
        bg-image-full('~@/icon/voice/person.png')
      .portrait-user
        white-space: nowrap
        color var(--pop-portrait-user);
        line-height: 40px
        font-size 18px
      .status_person
        position absolute
        top 0
        right 0
        width: 60px;
        height: 24px;
        line-height: 24px;
        background: var(--talk-status-bg);
        border-radius: 0px 0px 0px 4px;
        text-align center
        .status_cricl
          width: 8px;
          height: 8px;
          border-radius: 50%;
        .status_on
          background: #00D332;
        .status_off
          background: #949494;
        .person_on
          color #00D332
          font-size 18px
        .person_off
          color #949494
          font-size 18px
      .default
        background: var(--pop-person-default);
        color: var(--pop-person-default-border);
      .refuse
        background var(--pop-person-refuse)
        color var(--pop-person-refuse-border)
      .offLine
        background var(--pop-person-offLine)
        color var(--pop-person-offLine-border)
    .serach_line
      height 465px
      overflow auto
      margin-top 15px
    .person-add
      width: 80px;
      height: 80px;
      margin 8px
      background:var(--talk-add-bg)
      border-radius: 4px;
      cursor pointer
      display inline-block
      text-align center
      box-sizing border-box
      img
        width 20px
        height 20px
        margin-top 20px
      .add_more
        color var(--wailk-add-more-color)
        font-size: 14px
        line-heght 28px
    .add-light
      border: 1px dashed #A8C4EA
    .add-dark
      border: 1px dashed #03C3ED
.talk
  margin 0px auto
  position relative
  height 13%
  .play-icon
    cursor pointer
    width 80px
    height 80px
    border 1px solid #1485EE
    border-radius: 50%;
    background: #1485EE;
    position absolute
    left 50%
    top 50%
    transform translate(-50%, -50%)
  .play-light
    position absolute
    left 50%
    top 50%
    transform translate(-50%, -50%)
    width 28px
    height 37px
    bg-image-full('~@/icon/voice/luyin.png')
  .play-dark
    bg-image-full('~@/icon/voice/ic_record_btn.png')
  .loader
    position absolute
    left 50%
    top 50%
    transform translate(-50%, -50%)
  .endPlay-light
    bg-image-full('~@/icon/voice/record_end.png')
  .endPlay-dark
    bg-image-full('~@/icon/voice/ic_record_end.png')
  .send-cancel
    text-align center
    .send-btn
      width 118px
      height 118px
    .cancel-btn
      width 118px
      height 118px
  .row-btn
    display inline-block
  .stop-talk
    position absolute
    left 50%
    top 88%
    transform translate(-50%, 0)
    font-size 12px
    color #FF0040
.input-box
  margin 10px auto
#setRecord
  .addRecord
    position relative
    line-height 50px
    border-radius 4px
    padding 0 15px
    .back-record
      width 16px
      height 16px
      margin-right 7px
      cursor pointer
    .addRecord-title
      font-size 20px
      font-weight 600
    .sys-close-btn
      position absolute
      right 10px
      top 50%
      transform translate(0, -50%)
      display block
  .group
    font-size 18px
    font-weight bold
    line-height 40px
    width 80% !important
    .select-title
      margin-top 10px
    .search-add
      font-size 18px
  .broad
    height 287px
    .el-tree
      width 80% !important
  .setTree
    height 400px
    font-size 18px
    text-align center
    line-height 100px
    color red
>>>.el-tree-node__content>label.el-checkbox
  position: absolute!important
  right: 10px!important
>>>.el-tree .el-tree-node__children .is-checked .el-tree-node__label
  color var(--waike-check-color)
</style>
